import { PositionenItemResponse } from '@/types/service-response'
import moment from 'moment'

export class ProjectBookingPositionen {
  public constructor (
    readonly ID: number,
    readonly Selektiert: boolean,
    readonly Pos: number,
    readonly Bezeichnung: string | null,
    readonly SollMenge: number | null, //double
    readonly Verfuegbar: number | null, //double
    readonly Bestand: number | null, //double
    readonly InKommissionierung: number | null,
    readonly Gesperrte: number | null,
    readonly Reserviert: number | null, //double
    readonly Bestellt: number | null, //double
    readonly EinheitCode: string | null,
    readonly SplittErlaubt: boolean,
    readonly DatumSoll: string | null,
    readonly LetzterBeleg: string | null,
  ) {}

  static createFromResponse (responseData: PositionenItemResponse[]): Array<ProjectBookingPositionen> {
    let result: Array<ProjectBookingPositionen> = []
    if (responseData) {
      result = responseData.map((item: PositionenItemResponse) => {
        return new ProjectBookingPositionen(
          item.ID,
          item.Selektiert,
          item.Pos,
          item.Bezeichnung,
          item.SollMenge !== null ? parseFloat(item.SollMenge.toFixed(3)) : null,
          item.Verfuegbar !== null ? parseFloat(item.Verfuegbar.toFixed(3)) : null,
          item.Bestand !== null ? parseFloat(item.Bestand.toFixed(3)) : null,
          item.InKommissionierung,
          item.Gesperrte,
          item.Reserviert !== null ? parseFloat(item.Reserviert.toFixed(3)) : null,
          item.Bestellt !== null ? parseFloat(item.Bestellt.toFixed(3)) : null,
          item.EinheitCode,
          item.SplittErlaubt,
          item.DatumSoll ? moment(item.DatumSoll).format('DD.MM.YYYY') : null,
          item.LetzterBeleg
        )
      })
    }
    return result
  }
}
